<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="1">
        <informa></informa>
      </el-tab-pane>
      <el-tab-pane label="成员" name="2">
        <member refs='member'></member>
      </el-tab-pane>
      <el-tab-pane label="设置" name="3">
        <setup></setup>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import informa from '../../components/unit/informa.vue'
import setup from '../../components/unit/setup.vue'
import member from '../../components/unit/member.vue'

export default {
  data() {
    return {
      activeName: '1',
    }
  },
  components: {
    informa,
    setup,
    member
  }
}

</script>
<style lang="stylus" scoped>
.org-control {
  margin-left: 60px
}

.gov-p {
  margin-bottom: 15px
}

.org-p1 {
  margin-left: 15px;
}

.el-select {
  width: 300px;
}

.p-color1 {
  color: #000;
  font-size: 16px;
}

.p-color2 {
  margin-top: 20px;
  color: #ccc;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// unit.vue?128f21bd